import http from "../../../core/utils/apis/api";
const getAttendancesByTrainingIdAndDate= async (trainingId,sessionDate) => {
    try {
        const response = await http({
            method: 'GET',
            url: `/attendances/all/trainings/${trainingId}`,
            params: {
                sessionDate: sessionDate, 
              },
        });
        return response;
    } catch (e) {
        throw e;
    }
  
  }

  const validateAttendance= async (attendances) => {
    try {
        const response = await http({
            method: 'PATCH',
            url: `/attendances`,
            data: attendances,
        });
        return response;
    } catch (e) {
        throw e;
    }
  
  }

  const ValidatingAttendancesByManager = {
    getAttendancesByTrainingIdAndDate,
    validateAttendance
    
};

export default ValidatingAttendancesByManager;